var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1438 0H0V900H1438V0Z",
    fill: "#228B90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1439.32 778.638V899.913H1V403C14.814 407.223 28.2018 412.602 41.0045 419.072C86.0336 441.849 121.685 478.215 152.983 516.375C216.346 593.691 265.651 680.901 332.773 755.137C344.284 767.875 356.804 779.766 370.227 790.706C432.477 841.441 509.878 867.461 595.2 870.179C632.885 871.537 670.613 868.948 707.696 862.46C757.437 853.65 805.248 836.969 849.111 813.12C902.406 784.292 955.912 754.521 1014.71 737.76C1135.95 703.206 1267.01 727.233 1387.89 762.892C1405.09 767.948 1422.22 773.239 1439.32 778.638Z",
    fill: "#D35C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1439 0.0185547V122.181C1424.16 132.208 1408.8 141.521 1392.97 150.085C1352.91 171.829 1309.69 189.949 1263.81 195.258C1199.66 202.506 1132.02 193.101 1073.95 166.393C922.451 96.6868 804.317 96.4513 699.07 116.727L695.848 117.361C595.626 137.112 506.948 175.109 412.019 188.735C410.83 188.916 409.641 189.079 408.433 189.224C376.147 193.841 343.403 194.905 310.857 192.395C155.633 179.856 137.146 71.4462 0.677979 88.4786V0.0185547H1439Z",
    fill: "#EE7930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.e2f6bd83ba9863a5d279027638e629cd.svg";
export { ForwardRef as ReactComponent };